import React from 'react';
import ReactTable from "react-table";
import {connect} from 'react-redux';
import {fetchItemsChunks} from "./thunks";

class DataGrid extends React.Component
{
    constructor(props) {
        super(props);

        this.onPageChange = this.onPageChange.bind(this);
        this.onPageSizeChange = this.onPageSizeChange.bind(this);
        this.onSortedChange = this.onSortedChange.bind(this);
        this.onFilteredChange = this.onFilteredChange.bind(this);
    }

    componentDidMount() {
        this.fetchItemsChunksByProps();
    }

    reload() {
        this.fetchItemsChunksByProps();
    }

    fetchItemsChunksByProps() {
        this.props.fetchItemsChunks(
            this.props.gridId,
            this.props.url,
            this.props.gridCurrentPage,
            this.props.gridPerPage,
            this.props.gridSorted,
            this.props.gridFiltered,
            this.props.onFetchedItems,
        );
    }

    onPageChange(currentPage) {
        this.props.fetchItemsChunks(
            this.props.gridId,
            this.props.url,
            currentPage,
            this.props.gridPerPage,
            this.props.gridSorted,
            this.props.gridFiltered,
            this.props.onFetchedItems,
        );
    }

    onPageSizeChange(perPage, currentPage) {
        this.props.fetchItemsChunks(
            this.props.gridId,
            this.props.url,
            currentPage,
            perPage,
            this.props.gridSorted,
            this.props.gridFiltered,
            this.props.onFetchedItems,
        );
    }

    onSortedChange(sorted) {
        this.props.fetchItemsChunks(
            this.props.gridId,
            this.props.url,
            this.props.gridCurrentPage,
            this.props.gridPerPage,
            sorted,
            this.props.gridFiltered,
            this.props.onFetchedItems,
        );
    }

    onFilteredChange(filtered) {
        this.props.fetchItemsChunks(
            this.props.gridId,
            this.props.url,
            0,
            this.props.gridPerPage,
            this.props.gridSorted,
            filtered,
            this.props.onFetchedItems
        );
    }

    render() {
        return (
            <ReactTable
                className="pagesTable -highlight"
                data={this.props.data}
                columns={this.props.columns}
                loading={this.props.gridLoading}
                manual
                sorted={this.props.gridSorted}
                filtered={this.props.gridFiltered}
                pageSize={this.props.gridPerPage}
                page={this.props.gridCurrentPage}
                pages={this.props.gridTotalPages}
                onPageChange={this.onPageChange}
                onPageSizeChange={this.onPageSizeChange}
                onSortedChange={this.onSortedChange}
                onFilteredChange={this.onFilteredChange}
            />
        );
    }
}

const mapStateToProps = (state, props) => ({
    gridCurrentPage: state.grid[props.gridId].currentPage,
    gridPerPage: state.grid[props.gridId].perPage,
    gridSorted: state.grid[props.gridId].sorted,
    gridFiltered: state.grid[props.gridId].filtered,
    gridLoading: state.grid[props.gridId].loading,
    gridTotalPages: state.grid[props.gridId].totalPages
});

export default connect(mapStateToProps, {
    fetchItemsChunks
}, null, {withRef: true })(DataGrid);


// WEBPACK FOOTER //
// ./src/containers/grid/grid.js